define(['jquery', 'jquery.history'], function ($) {
    var type = '';
    var take = 0;
    var page = 1;
    var isLoadMore = false;
    var currentIndex = 1;
    var $resultListArea = $(".js-news-listing");
    var results = [];
    var $flexgridTitles = $('.js-flexgrid-title');

    $(function () {
        History.pushState({}, document.title, window.location.href);
        $('.js-view-more').hide();
        take = parseInt($(".js-news-landing").attr("data-take"));
        type = $(".js-news-landing").attr("data-type");
        updateTitleHeights();
        GetSearchResults();
    }());

    $(window).on('resize', function () {
        updateTitleHeights();
    })

    function updateTitleHeights() {
        if ($(this).width() > 1200) {
            for (var i = 0; i < $flexgridTitles.length; i++) {
                if ($flexgridTitles[i + 1]) {
                    $($flexgridTitles[i]).css('height', 'auto');
                    $($flexgridTitles[i + 1]).css('height', 'auto');

                    if ($($flexgridTitles[i]).outerHeight() > $($flexgridTitles[i + 1]).outerHeight()) {
                        $($flexgridTitles[i + 1]).css('height', $($flexgridTitles[i]).outerHeight());
                    } else {
                        $($flexgridTitles[i]).css('height', $($flexgridTitles[i + 1]).outerHeight());
                    }
                    i = i + 1;
                }
            }
        } else {
            for (var i = 0; i < $flexgridTitles.length; i++) {
                $($flexgridTitles[i]).css('height', 'auto');
            }
        }
    }

    $('.js-landing-search__input').on('keypress', function (e) {
        if (e.which == 13) { redirectToSearch($(this).val()); }
    });

    $('.js-landing-search__button').on('click', function (e) {
        var keyword = $(this).parent().find('.js-landing-search__input.search-input-large').val();
        if (!keyword) {
            keyword = $(this).parent().find('.js-landing-search__input.search-input-small').val();
        }
        if (keyword) {
            redirectToSearch(keyword);
        }
    });

    $('.js-view-more').on('click', function () {
        isLoadMore = true;
        LoadListItems(currentIndex);
    });

    function GetSearchResults() {
        $(".loading-image").hide();
        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetListingResults",
            data: JSON.stringify({ type: type, categoryId: '', topicId: '', startPage: page, keyWord: '' }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                results = response.d;
                currentIndex = 1;

                if (results.length == 0) {
                    $(".loading-image").hide();
                }

                //clear previous search results if load more is false
                if (!isLoadMore) {
                    $resultListArea.html('');
                }

                LoadListItems(currentIndex)

                $resultListArea.show();
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadListItems(index) {
        if (index > results.length || index >= (currentIndex + take)) {
            if (results.length <= (page * take)) {
                $('.js-view-more').hide();
            } else {
                $('.js-view-more').show();
            }
            $(".loading-image").hide();

            currentIndex = index;
            page++;
            return;
        }

        var ajaxUrl = "/Layouts/WebUserControls/Main/Insights/AjaxLoadListItem.aspx?guid=" + results[index - 1];
        $.ajax({ url: ajaxUrl })
            .done(function (p) {
                $resultListArea.append(p);
                $resultListArea.fadeIn();
                LoadListItems(index + 1)
                $(".loading-image").hide();
            });
    }

    function redirectToSearch(keyword) {
        var url = window.location.href + '/search?keyword=' + encodeURIComponent(keyword);
        History.pushState({}, document.title, url);
        window.location.replace(url);
    }
});